import React, { useEffect, useState } from 'react';
import CoachMenuLayout from '../../../layouts/CoachMenuLayout';
import { useDispatch, useSelector } from 'react-redux';
import { authChangePassword, coachDeleteAccount, coachDisableAccount, coachPlanCancel, fetchAllCoachOffers, fetchCoachProfileData, fetchCoachSubscription, updateProfile } from '../../../redux/features/coach/actions/coachAction';
import Loader from '../../../components/loader';
import { curSym, pipViewDate2 } from '../../../utils/pip';
import { Formik } from 'formik';
import { changePasswordSchema, updateProfileSchema } from '../../../utils/schema';
import { coachPaths } from '../../../routes/coach';
import { useLocation, useNavigate } from 'react-router-dom';
import ErrorMessage from '../../../components/form/ErrorMessage';
import Eye from '../../../components/form/Eye';
import CoachDisableConfirmationModal from "../../../components/Modals/common/CoachDisableConfirmationModal";
import { State, City, Country } from "country-state-city";
import toast from 'react-hot-toast';
import Offers from '../../../components/pages/find-a-job/Offers';

const CoachSetting = () => {
  const { coachSubscriptionPlan, isLoading2, coachProfile, coachOfferList } = useSelector((state) => state.coach.coach);
  const [accountInformation, setAccountInformation] = useState("Security");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [isEye, setIsEye] = useState(false);
  const [isEye1, setIsEye1] = useState(false);

  const [isEye2, setIsEye2] = useState(false);
  const [isModalShow, setIsModalShow] = useState(false);

  const [isDeleteAccount, setIsDeleteAccount] = useState(false);
  const [isSubscriptionCancel, setIsSubscriptionCancel] = useState(false);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [language, setLanguages] = useState([""]);


  const initialValues = {
    new_password: "",
    current_password: "",
    confirm_password: ""
  };

  useEffect(() => {
    if (!coachProfile?.language) {
      setLanguages([]);
      return;
    };
    const data = coachProfile.language.split(",").map(item => item.trim());
    setLanguages(data);
  }, [coachProfile]);

  const initialValues1 = {
    full_name: coachProfile?.full_name ?? "",
    email: coachProfile?.email ?? "",
    gender: coachProfile?.gender ?? null,
    dob: coachProfile?.dob ?? null,
    phone_number: coachProfile?.phone_number ?? "",
    language: coachProfile?.language ?? "",
    address_1: coachProfile?.coach?.address_1 ?? "",
    address_2: coachProfile?.coach?.address_2 ?? "",
    bio: coachProfile?.coach?.bio ?? "",
    city: coachProfile?.coach?.city ?? "",
    country: coachProfile?.coach?.country ?? "",
    reason: coachProfile?.coach?.reason ?? "",
    tagline: coachProfile?.coach?.tagline ?? "",
    state: coachProfile?.coach?.state ?? "",
    year_of_experience: coachProfile?.coach?.year_of_experience ?? "",
    zip_code: coachProfile?.coach?.zip_code ?? ""
  };

  useEffect(() => {
    dispatch(fetchCoachSubscription());
    dispatch(fetchCoachProfileData());
    dispatch(fetchAllCoachOffers());
    setCountries(Country.getAllCountries());
  }, []);

  useEffect(() => {
    if (location?.state?.tab) {
      setAccountInformation(location.state.tab);
    }
  }, [location]);

  const handleChangePassword = (values) => {
    const callback = (response) => {
      if (response.success) {
        navigate(coachPaths?.CoachSettings);
      };
    };
    const data = {
      old_password: values?.current_password,
      new_password: values?.new_password
    };
    dispatch(authChangePassword({ payload: data, callback }));
  };

  const handleUpdateProfile = (values) => {
    const isAnyEmpty = language.some(item => !item.trim());
    if (isAnyEmpty) {
      toast.error("Please fill all language fields or remove the empty ones.");
      return;
    };
    values.language = language?.join(',');
    values.gender = values?.gender == "" ? null : values?.gender;
    values.dob = values?.dob == "" ? null : values?.dob;
    values.year_of_experience = `${values?.year_of_experience || 0}`;
    delete values.email;
    const callback = (response) => {
      dispatch(fetchCoachProfileData());
    };
    dispatch(updateProfile({ callback, payload: values }))
  };

  const handleDisableAccount = () => {
    const callback = (response) => {
      if (response.success) {
        localStorage.removeItem("coach_token_nuvio")
        navigate(coachPaths?.WebinarData);
      };
    };
    dispatch(coachDisableAccount({ callback }));
  };

  const handleDeleteAccount = () => {
    const callback = (response) => {
      if (response.success) {
        localStorage.removeItem("coach_token_nuvio")
        navigate(coachPaths?.WebinarData);
      };
    };
    dispatch(coachDeleteAccount({ callback }));
  };

  const handlePlanCancelSubScription = () => {
    const callback = (response) => {
      if (response.success) {
        dispatch(fetchCoachSubscription());
        setAccountInformation("Subscription");
        setIsSubscriptionCancel(false);
      };
    };
    dispatch(coachPlanCancel({ callback }));
  };

  const handleAddLanguage = () => {
    setLanguages((prev) => [...prev, ""]);
  };

  const handleLanguageChange = (index, newValue) => {
    const updated = [...language];
    updated[index] = newValue;
    setLanguages(updated);
  };

  const handleRemoveLanguage = (index) => {
    setLanguages((prev) => prev.filter((_, i) => i !== index));
  };

  if (isLoading2) {
    return <Loader />
  };
  return (
    <CoachMenuLayout>
      <div className="mt-4 ct_px_40 pb-5">
        <div className="ct_mb_20">
          <h4 className="ct_fs_20_new ct_fw_600 ct_darksky_blue_text">
            Settings
          </h4>
          <p className="mb-0 ct_grey_text">
            Manage your account settings and set e-mail prefernces
          </p>
        </div>

        <div className="row ct_pt_20 ct_border_top_1_op_10 ct_mt_20">
          <div className="col-lg-3 mb-4 ">
            <div className="ct_setting_tabs">
              <div
                class="nav flex-column nav-pills me-3"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                {/* <button
                  class={`nav-link ${accountInformation == "Account" && "active"
                    }`}
                  id="v-pills-Account-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Account"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Account"
                  aria-selected="true"
                  onClick={() => setAccountInformation("Account")}
                >
                  Account
                </button> */}
                <button
                  class={`nav-link ${accountInformation == "Security" && "active"
                    }`}
                  id="v-pills-Security_&_Password-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Security_&_Password"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Security_&_Password"
                  aria-selected="false"
                  onClick={() => setAccountInformation("Security")}
                >
                  Security & Password
                </button>
                <button
                  class={`nav-link ${accountInformation == "Subscription" && "active"
                    }`}
                  id="v-pills-Subscription_&_Plan-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Subscription_&_Plan"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Subscription_&_Plan"
                  aria-selected="false"
                  onClick={() => setAccountInformation("Subscription")}
                >
                  Subscription & Plan
                </button>
                <button
                  class={`nav-link ${accountInformation == "Notifications" && "active"
                    }`}
                  id="v-pills-Notifications-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Notifications"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Notifications"
                  aria-selected="false"
                  onClick={() => setAccountInformation("Notifications")}
                >
                  Notifications
                </button>
                <button
                  class={`nav-link ${accountInformation == "Offers" && "active"
                    }`}
                  id="v-pills-Offers-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Offers"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Offers"
                  aria-selected="false"
                  onClick={() => setAccountInformation("Offers")}
                >
                  Offers
                </button>
              </div>
            </div>
          </div>
          <div className="col-lg-9  mb-4 ">
            <div class="tab-content" id="v-pills-tabContent">
              <div
                class={`tab-pane fade ${accountInformation == "Account" && "show active"
                  }`}
                id="v-pills-Account"
                role="tabpanel"
                aria-labelledby="v-pills-Account-tab"
              >
                <div className="ct_px_40">
                  <div>
                    <div>
                      <h4 className="ct_fs_16 ct_darksky_blue_text">
                        Account Information
                      </h4>
                      <p className="mb-0 ct_grey_text">
                        Ths is how others will see you on the Nuvio Platform
                      </p>
                    </div>
                    <Formik
                      initialValues={initialValues1}
                      validationSchema={updateProfileSchema}
                      onSubmit={(values, actions) => {
                        handleUpdateProfile(values);
                      }}
                      enableReinitialize
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        resetForm,
                      }) => (
                        <form className="mt-4">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Full Name
                                </label>
                                <input
                                  value={values?.full_name}
                                  id="full_name"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  type="text"
                                  className="form-control ct_input_border_8"
                                  placeholder="Enter full name"
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"full_name"}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Email
                                </label>
                                <input
                                  value={values?.email}
                                  readOnly
                                  type="email"
                                  className="form-control ct_input_border_8"
                                  placeholder="Enter email"
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"email"}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Date Of Birth
                                </label>
                                <input
                                  type="date"
                                  className="form-control ct_input_border_8"
                                  value={values?.dob}
                                  id="dob"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  max={new Date().toISOString().split("T")[0]}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"dob"}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2  ct_fs_14 ct_grey_text">
                                  Gender
                                </label>
                                <select
                                  className="form-control ct_input_border_8"
                                  id="gender"
                                  value={values?.gender}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <option value="">Please select gender</option>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                  <option value="Other">Other</option>
                                </select>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"gender"}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Phone Number
                                </label>
                                <input
                                  type="text"
                                  placeholder="Phone Number"
                                  className="form-control ct_input"
                                  id="phone_number"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values?.phone_number}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"phone_number"}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Year of Experience
                                </label>
                                <input
                                  type="number"
                                  placeholder="Phone Number"
                                  className="form-control ct_input"
                                  id="year_of_experience"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values?.year_of_experience}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"year_of_experience"}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Bio
                                </label>
                                <textarea
                                  type="text"
                                  placeholder="Bio"
                                  className="form-control ct_input h-auto"
                                  rows={3}
                                  id="bio"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values?.bio}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"bio"}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Reason
                                </label>
                                <textarea
                                  type="text"
                                  rows={3}
                                  placeholder="Reason"
                                  className="form-control ct_input h-auto"
                                  id="reason"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values?.reason}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"reason"}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Tagline
                                </label>
                                <textarea
                                  type="text"
                                  placeholder="Tagline"
                                  className="form-control ct_input h-auto"
                                  rows={3}
                                  id="tagline"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values?.tagline}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"tagline"}
                                />
                              </div>
                            </div>

                            {/* <div className="col-md-6"></div> */}
                          </div>
                          <div className="mt-2">
                            <div>
                              <h4 className="ct_fs_16 ct_darksky_blue_text">
                                Region & Language
                              </h4>
                              <p className="mb-0 ct_grey_text">
                                Ths is how others will see you on the Nuvio
                                Platform
                              </p>
                            </div>
                            <div className="mt-4">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group mb-4">
                                    <label className="mb-2 ct_fs_14 ct_grey_text">
                                      Country
                                    </label>
                                    <select
                                      className="form-control ct_input_border_8"
                                      id="country"
                                      value={values.country}
                                      onChange={(e) => {
                                        const countryName = e.target.value;
                                        handleChange(e);

                                        const selectedCountry = countries.find(
                                          (c) => c.name === countryName
                                        );

                                        if (selectedCountry) {
                                          const statesData =
                                            State.getStatesOfCountry(
                                              selectedCountry.isoCode
                                            );
                                          setStates(statesData);
                                          setCities([]);
                                          setFieldValue("state", "");
                                          setFieldValue("city", "");
                                        } else {
                                          setStates([]);
                                          setCities([]);
                                        }
                                      }}
                                      onBlur={handleBlur}
                                    >
                                      <option value="">
                                        -- Select Country --
                                      </option>
                                      {countries.map((country) => (
                                        <option
                                          key={country.isoCode}
                                          value={country.name}
                                        >
                                          {country.name}
                                        </option>
                                      ))}
                                    </select>
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName={"country"}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group mb-4">
                                    <label className="mb-2 ct_fs_14 ct_grey_text">
                                      State
                                    </label>

                                    <select
                                      className="form-control ct_input_border_8"
                                      id="state"
                                      value={values.state}
                                      onChange={(e) => {
                                        const stateName = e.target.value;
                                        handleChange(e);

                                        const selectedCountry = countries.find(
                                          (c) => c.name === values.country
                                        );

                                        const selectedState = states.find(
                                          (s) => s.name === stateName
                                        );

                                        if (selectedCountry && selectedState) {
                                          const citiesData =
                                            City.getCitiesOfState(
                                              selectedCountry.isoCode,
                                              selectedState.isoCode
                                            );
                                          setCities(citiesData);
                                          setFieldValue("city", "");
                                        } else {
                                          setCities([]);
                                        }
                                      }}
                                      onBlur={handleBlur}
                                      disabled={!values.country}
                                    >
                                      <option value="">
                                        -- Select State --
                                      </option>
                                      {states.map((state) => (
                                        <option
                                          key={state.isoCode}
                                          value={state.name}
                                        >
                                          {state.name}
                                        </option>
                                      ))}
                                    </select>
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName={"state"}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group mb-4">
                                    <label className="mb-2 ct_fs_14 ct_grey_text">
                                      Address Line 1
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control ct_input_border_8"
                                      placeholder="Address line 1"
                                      id="address_1"
                                      value={values.address_1}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName={"address_1"}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group mb-4">
                                    <label className="mb-2 ct_fs_14 ct_grey_text">
                                      Address Line 2
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control ct_input_border_8"
                                      placeholder="Type here"
                                      id="address_2"
                                      value={values.address_2}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName={"address_2"}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group mb-4">
                                    <label className="mb-2 ct_fs_14 ct_grey_text">
                                      City
                                    </label>
                                    <select
                                      className="form-control ct_input_border_8"
                                      id="city"
                                      value={values.city}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      disabled={!values.state}
                                    >
                                      <option value="">
                                        -- Select City --
                                      </option>
                                      {cities.map((city) => (
                                        <option
                                          key={city.name}
                                          value={city.name}
                                        >
                                          {city.name}
                                        </option>
                                      ))}
                                    </select>
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName={"state"}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group mb-4">
                                    <label className="mb-2 ct_fs_14 ct_grey_text">
                                      Zip/Postal Code
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control ct_input_border_8"
                                      placeholder="Type here"
                                      id="zip_code"
                                      value={values?.zip_code}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName={"zip_code"}
                                    />
                                  </div>
                                </div>

                                {language.map((lang, index) => (
                                  <div className="col-md-6">
                                    <div
                                      key={index}
                                      className="d-flex gap-2 mb-2"
                                    >
                                      <input
                                        type="text"
                                        value={lang}
                                        onChange={(e) =>
                                          handleLanguageChange(
                                            index,
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        placeholder="Enter language"
                                      />
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleRemoveLanguage(index)
                                        }
                                        className="btn btn-danger ct_white_nowrap"
                                      >
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                ))}
                                <span
                                  className="ct_darksky_blue_text ct_fw_600 mb-0 mt-2 ct_cursor_pointer"
                                  style={{ width: "fit-content" }}
                                  onClick={handleAddLanguage}
                                >
                                  + Add Language
                                </span>
                              </div>
                              <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                                <button className="ct_yellow_btn ct_grey_btn ct_h_44 px-5">
                                  Cancel
                                </button>
                                <button
                                  className="ct_yellow_btn  ct_sky_blue_btn ct_h_44 px-5"
                                  onClick={handleSubmit}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
              <div
                class={`tab-pane fade ${accountInformation == "Subscription" && "show active"
                  }`}
                id="v-pills-Subscription_&_Plan"
                role="tabpanel"
                aria-labelledby="v-pills-Subscription_&_Plan-tab"
              >
                <div>
                  <h4 className="ct_fs_16 ct_darksky_blue_text">
                    Subscription Plan
                  </h4>
                  <p className="mb-0 ct_grey_text">
                    You can always upgrade for better visibility and client
                  </p>
                </div>
                {coachSubscriptionPlan &&
                  coachSubscriptionPlan?.length != 0 &&
                  coachSubscriptionPlan?.slice(0, 1)?.map((item) => (
                    <div className="row ct_mt_60">
                      <div className="col-lg-6 mb-4 mb-lg-0">
                        <div className="ct_light_yellow_subscription_bg d-none">
                          <div className="d-flex align-items-center gap-3 justify-content-between">
                            <h4 className="ct_fs_14 ct_darkblue_text mb-0">
                              FREE PLAN
                            </h4>
                            <button className="ct_white_btn ct_white_nowrap">
                              Upgrade Plan
                            </button>
                          </div>
                          <div className="d-flex align-items-center gap-3 justify-content-between mt-4">
                            <div>
                              <h4 className="ct_fs_24_new ct_fw_500">
                                0.00 &nbsp;
                                <small className="ct_fs_14">{curSym}</small>
                              </h4>
                              <button className="ct_white_btn d-flex align-items-center gap-3 mt-3">
                                <img src="../assets/img/warning-2.png" />
                                <span className="ct_red_text ct_white_nowrap">
                                  {" "}
                                  Free trial -3 days left{" "}
                                </span>
                              </button>
                            </div>
                            <div className="ct_right_vector_img_subs">
                              <img src="../assets/img/cuate.png" />
                            </div>
                          </div>
                        </div>
                        <div className="ct_light_yellow_subscription_bg">
                          <div className="d-flex align-items-start gap-3 justify-content-between">
                            <div>
                              <h4 className="ct_fs_15 ct_fw_600 ct_darksky_blue_text mb-1">
                                {item?.title ?? ""}
                              </h4>
                              <p className="ct_yellow_text ct_fs_12 ct_fw_600">
                                {item?.description ?? ""}
                              </p>
                            </div>
                            <button className="ct_white_btn ct_white_nowrap">
                              Upgrade Plan
                            </button>
                          </div>
                          <div className="d-flex align-items-center gap-3 justify-content-between mt-4">
                            <div>
                              <h4 className="ct_fs_24_new ct_fw_500">
                                {parseFloat(item?.total_price ?? 0)?.toFixed(2)}{" "}
                                &nbsp;
                                <small className="ct_fs_14">{curSym}</small>
                              </h4>
                              <button className="ct_white_btn d-flex align-items-center gap-3 mt-3">
                                <img src="../assets/img/warning-2.png" />
                                <span className="ct_red_text   ">
                                  {" "}
                                  {item?.title ?? ""} - {item?.days_left || 0}{" "}
                                  days left{" "}
                                </span>
                              </button>
                            </div>
                            <div className="ct_right_vector_img_subs">
                              <img src="../assets/img/cuate.png" />
                            </div>
                          </div>
                        </div>
                      </div>
                      {item?.auto_pay && (
                        <div className="col-lg-6 mb-4 mb-lg-0 pe-5">
                          <div className="ct_white_border_bg">
                            <div className="d-flex align-items-start justify-content-between gap-3">
                              <p className="ct_fs_14 mb-0">NEXT BILLING DATE</p>
                              <button
                                className="ct_red_btn_12 ct_white_nowrap"
                                onClick={() => setIsSubscriptionCancel(true)}
                              >
                                Cancel Plan
                              </button>
                            </div>
                            <div className="mt-auto">
                              <h3 className="ct_fs_21 mb-2">
                                {pipViewDate2(item?.next_billing_date)}
                              </h3>
                              <p className="ct_grey_text ct_fs_14 mb-0">
                                This is your next billing date
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                <div className="row ct_border_top_1_op_10 ct_mt_40 ct_pt_40 d-none">
                  <div className="col-lg-6 mb-4 mb-lg-0">
                    <div className="">
                      <div className="mb-4">
                        <p className="ct_darkblue_text mb-1">Payment Method</p>
                        <p className="ct_grey_text ct_fs_14 mb-0">
                          Manage your credit cards and payment options.
                        </p>
                      </div>

                      <div className="ct_no_payment_empty_card">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.4"
                            d="M19 10.2769V17.4269C18.97 20.2769 18.19 20.9969 15.22 20.9969H5.78003C2.76003 20.9969 2 20.2469 2 17.2669V10.2769C2 7.57687 2.63 6.70687 5 6.56687C5.24 6.55687 5.50003 6.54688 5.78003 6.54688H15.22C18.24 6.54688 19 7.29687 19 10.2769Z"
                            fill="#292D32"
                          />
                          <path
                            d="M22 6.73V13.72C22 16.42 21.37 17.29 19 17.43V10.28C19 7.3 18.24 6.55 15.22 6.55H5.78003C5.50003 6.55 5.24 6.56 5 6.57C5.03 3.72 5.81003 3 8.78003 3H18.22C21.24 3 22 3.75 22 6.73Z"
                            fill="#292D32"
                          />
                          <path
                            d="M6.96027 18.5625H5.24023C4.83023 18.5625 4.49023 18.2225 4.49023 17.8125C4.49023 17.4025 4.83023 17.0625 5.24023 17.0625H6.96027C7.37027 17.0625 7.71027 17.4025 7.71027 17.8125C7.71027 18.2225 7.38027 18.5625 6.96027 18.5625Z"
                            fill="#292D32"
                          />
                          <path
                            d="M12.5504 18.5625H9.11035C8.70035 18.5625 8.36035 18.2225 8.36035 17.8125C8.36035 17.4025 8.70035 17.0625 9.11035 17.0625H12.5504C12.9604 17.0625 13.3004 17.4025 13.3004 17.8125C13.3004 18.2225 12.9704 18.5625 12.5504 18.5625Z"
                            fill="#292D32"
                          />
                          <path
                            d="M19 11.8594H2V13.3594H19V11.8594Z"
                            fill="#292D32"
                          />
                        </svg>
                        <h6 className="ct_fs_16 ct_dark_blue_text ct_mt_16">
                          No payment method
                        </h6>
                        <button className="ct_yellow_btn ct_outline_yellow_new ct_border_radius_100 ct_h_40 ct_yellow_text mx-auto mt-3">
                          Add Payment Method
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row ct_border_top_1_op_10 ct_mt_40 ct_pt_40">
                  <div className="col-lg-12 pe-5">
                    <div className="">
                      <div className="mb-4 d-flex align-items-center gap-3 justify-content-between ct_flex_col_575">
                        <div>
                          <p className="ct_darkblue_text mb-1">
                            Payment Method
                          </p>
                          <p className="ct_grey_text ct_fs_14 mb-0">
                            Manage your payment methods here.
                          </p>
                        </div>
                        <a
                          href="javascript:void(0)"
                          className="ct_fs_14 ct_yellow_link"
                        >
                          CHANGE PAYMENT METHOD
                        </a>
                      </div>

                      <div className="ct_payment_options_list">
                        <ul className="mb-0">
                          <li className="ct_payments_option_card">
                            <div className="d-flex align-items-center gap-3">
                              <img src="../assets/img/Visa.png" />
                              <div>
                                <h6 className="ct_fs_16 mb-1">
                                  <span className="me-2">
                                    {" "}
                                    Visa Debit Card{" "}
                                  </span>
                                  <span
                                    className="ct_default_badge ct_orange_text "
                                    style={{
                                      background: "hsl(32deg 100% 49% / 20%)",
                                    }}
                                  >
                                    Default
                                  </span>
                                </h6>
                                <p className="mb-0 ct_grey_text ct_fs_12">
                                  **** **** **** 2897
                                </p>
                              </div>
                            </div>
                            <div>
                              <img src="../assets/img/Delete_card.png" />
                            </div>
                          </li>
                          <li className="ct_payments_option_card">
                            <div className="d-flex align-items-center gap-3">
                              <img src="../assets/img/mastercard.png" />
                              <div>
                                <h6 className="ct_fs_16 mb-1">
                                  <span className="me-2"> Mastercard </span>
                                  <span
                                    className="ct_default_badge ct_darksky_blue_text "
                                    style={{
                                      background: "hsl(199deg 64% 73% / 50%)",
                                    }}
                                  >
                                    Default
                                  </span>
                                </h6>
                                <p className="mb-0 ct_grey_text ct_fs_12">
                                  **** **** **** 2897
                                </p>
                              </div>
                            </div>
                            <div>
                              <img src="../assets/img/Delete_card.png" />
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div className="ct_border_top_1_op_10 pt-3 ct_mt_40">
                        <h4 className="ct_fs_18 mb-3">
                          Add New Payment Method
                        </h4>
                        <div className="mt-4">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Name on Card
                                </label>
                                <input
                                  type="text"
                                  className="form-control ct_input_border_8"
                                  placeholder="Enter Name on Card"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Expiry
                                </label>
                                <input
                                  type="date"
                                  className="form-control ct_input_border_8"
                                  placeholder=" Type here"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2  ct_fs_14 ct_grey_text">
                                  Card number
                                </label>
                                <div className="position-relative">
                                  <input
                                    type="number"
                                    className="form-control ct_input_border_8"
                                    style={{ paddingLeft: "60px" }}
                                    placeholder="Enter  Card number"
                                  />

                                  <div className="ct_input_icon_left">
                                    <svg
                                      width="34"
                                      height="24"
                                      viewBox="0 0 34 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        x="0.5"
                                        y="0.5"
                                        width="33"
                                        height="23"
                                        rx="3.5"
                                        fill="white"
                                      />
                                      <rect
                                        x="0.5"
                                        y="0.5"
                                        width="33"
                                        height="23"
                                        rx="3.5"
                                        stroke="#F5F5F5"
                                      />
                                      <path
                                        d="M21.5771 5.03125C25.322 5.03125 28.3584 8.03114 28.3584 11.7314C28.3583 15.4317 25.322 18.4316 21.5771 18.4316C19.8982 18.4316 18.3629 17.8269 17.1787 16.8281C15.9945 17.8267 14.4591 18.4316 12.7803 18.4316C9.03566 18.4314 6.00011 15.4315 6 11.7314C6 8.03127 9.03559 5.03147 12.7803 5.03125C14.459 5.03125 15.9945 5.63533 17.1787 6.63379C18.3629 5.63519 19.8983 5.03128 21.5771 5.03125Z"
                                        fill="#ED0006"
                                      />
                                      <path
                                        d="M21.5771 5.03125C25.322 5.03133 28.3574 8.03119 28.3574 11.7314C28.3573 15.4316 25.3219 18.4316 21.5771 18.4316C19.8982 18.4316 18.3629 17.8268 17.1787 16.8281C18.6359 15.5993 19.5615 13.7727 19.5615 11.7314C19.5615 9.68995 18.6361 7.86269 17.1787 6.63379C18.3629 5.63525 19.8984 5.03125 21.5771 5.03125Z"
                                        fill="#F9A000"
                                      />
                                      <path
                                        d="M17.1787 6.63281C18.6363 7.86171 19.5615 9.68883 19.5615 11.7305C19.5615 13.7719 18.636 15.5983 17.1787 16.8271C15.7217 15.5983 14.7969 13.7716 14.7969 11.7305C14.7969 9.68913 15.7215 7.86171 17.1787 6.63281Z"
                                        fill="#FF5E00"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  CVV
                                </label>
                                <input
                                  type="number"
                                  className="form-control ct_input_border_8"
                                  placeholder="Enter CVV"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                            <button
                              className="ct_yellow_btn   px-5"
                              data-bs-toggle="modal"
                              data-bs-target="#ct_add_payment_method"
                            >
                              Add Payment Method
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class={`tab-pane fade ${accountInformation == "Security" && "show active"
                  }`}
                id="v-pills-Security_&_Password"
                role="tabpanel"
                aria-labelledby="v-pills-Security_&_Password-tab"
              >
                <div>
                  <h4 className="ct_fs_16 ct_darksky_blue_text">
                    Change Password
                  </h4>
                  <p className="mb-0 ct_grey_text">
                    Changing your password will log out of all your active
                    sessions
                  </p>
                </div>
                <Formik
                  initialValues={initialValues}
                  validationSchema={changePasswordSchema}
                  onSubmit={(values, actions) => {
                    handleChangePassword(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    resetForm,
                  }) => (
                    <form className="mt-4">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label className="mb-2 ct_fs_14 ct_grey_text">
                              Current Password
                            </label>
                            <div className="position-relative">
                              <input
                                type={isEye ? "text" : "password"}
                                className="form-control ct_input ct_border_op_10 pe-5"
                                placeholder="Current Password"
                                id="current_password"
                                value={values.current_password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              <Eye
                                isEye={isEye}
                                onClick={() => setIsEye(!isEye)}
                              />
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="current_password"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label className="mb-2 ct_fs_14 ct_grey_text">
                              New Password
                            </label>
                            <div className="position-relative">
                              <input
                                type={isEye1 ? "text" : "password"}
                                className="form-control ct_input ct_border_op_10 pe-5"
                                placeholder="New Password"
                                id="new_password"
                                value={values.new_password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              <Eye
                                isEye={isEye1}
                                onClick={() => setIsEye1(!isEye1)}
                              />
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="new_password"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label className="mb-2 ct_fs_14 ct_grey_text">
                              Confirm Password
                            </label>
                            <div className="position-relative">
                              <input
                                type={isEye2 ? "text" : "password"}
                                className="form-control ct_input ct_border_op_10 pe-5"
                                placeholder="Confirm Password"
                                id="confirm_password"
                                value={values?.confirm_password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              <Eye
                                isEye={isEye2}
                                onClick={() => setIsEye2(!isEye2)}
                              />
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="confirm_password"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center  gap-3 mt-4">
                        <button
                          className="ct_yellow_btn ct_outline_light_grey px-5"
                          type="button"
                          onClick={() => resetForm()}
                        >
                          Discard
                        </button>
                        <button
                          className="ct_yellow_btn px-5"
                          type="button"
                          onClick={handleSubmit}
                        >
                          Save New Password
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
                <div
                  className="ct_no_factor_Authentication_outline"
                  style={{ marginTop: "80px" }}
                >
                  <p className="mb-0 ct_fs_18">Two- Factor Authentication</p>
                  <div class="d-flex align-items-center gap-2">
                    <label class="toggle-switch ct_toggle_switch_h_16 ct_white_nowrap">
                      <input type="checkbox" />
                      <div class="toggle-switch-background">
                        <div class="toggle-switch-handle"></div>
                      </div>
                    </label>
                    <span className="ct_white_nowrap"> Disabled</span>
                  </div>
                </div>

                <div className="ct_mt_30">
                  <h6 className="ct_fs_18 mb-3">Profile Privacy</h6>
                  <ul>
                    <li>
                      <div className="ct_no_factor_Authentication_outline align-items-start ct_py_15_px_20">
                        <div>
                          <h6 className="mb-2 ct_fs_18">
                            Hide Number of Hired Candidates
                          </h6>
                          <p className="ct_grey_text mb-0">
                            You can make some details of your jobs on the
                            marketplace private
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <label class="toggle-switch ct_toggle_switch_h_16 ">
                            <input type="checkbox" />
                            <div class="toggle-switch-background">
                              <div class="toggle-switch-handle"></div>
                            </div>
                          </label>
                          <span className="ct_white_nowrap">Enable</span>
                        </div>
                      </div>
                    </li>
                    <li className="ct_mt_30">
                      <div className="ct_no_factor_Authentication_outline align-items-start ct_py_15_px_20">
                        <div>
                          <h6 className="mb-2 ct_fs_18">Reset Account</h6>
                          <p className="ct_grey_text mb-0">
                            Choose this to irreversibly remove your account and
                            data, ensuring no future access or recovery.
                          </p>

                          <button
                            className="ct_yellow_btn ct_sky_light_btn_new mt-2 ct_border_radius_100 ct_h_48"
                            onClick={() => setIsModalShow(true)}
                          >
                            Disable Account
                          </button>
                        </div>
                      </div>
                    </li>
                    <li className="ct_mt_30">
                      <div className="ct_no_factor_Authentication_outline align-items-start ct_py_15_px_20">
                        <div>
                          <h6 className="mb-2 ct_fs_18">Delete My Account</h6>
                          <p className="ct_grey_text mb-0">
                            Choose this to irreversibly remove your account and
                            data, ensuring no future access or recovery.
                          </p>

                          <button
                            className="ct_yellow_btn ct_orange_btn mt-2 ct_border_radius_100 ct_h_48"
                            onClick={() => setIsDeleteAccount(true)}
                          >
                            Delete My Account
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class={`tab-pane fade ${accountInformation == "Notifications" && "show active"
                  }`}
                id="v-pills-Notifications"
                role="tabpanel"
                aria-labelledby="v-pills-Notifications-tab"
              >
                ...
              </div>
              <Offers
                accountInformation={accountInformation}
                data={coachOfferList}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade modal-lg"
        id="ct_add_payment_method"
        tabindex="-1"
        aria-labelledby="ct_create_eventLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body px-5 pb-5 ">
              <div className="text-center">
                <h4 class=" mb-1 ct_fs_24_new ct_darksky_blue_text px-4">
                  Payment method
                </h4>
                <p class="mb-0 ct_grey_text ct_fs_12 px-4">
                  Update, change, or add a payment method securely for
                  hassle-free billing.
                </p>
              </div>
              <div className="ct_mt_30">
                <div className="form-check ct_custom_check2 ct_custom_check_sky_blue  d-flex align-items-center gap-2 mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefault"
                  />
                  <label for="" className="ct_darksky_blue_text">
                    Business Purchase
                  </label>
                </div>

                <div className="mb-3">
                  <label className="ct_fs_14 ct_darkblue_text mb-2">
                    Choose payment method
                  </label>
                  <div className="d-flex align-items-center gap-3">
                    <div className="ct_select_payment_type">
                      <img src="../assets/img/visa_big_logo.png" />
                    </div>
                    <div className="ct_select_payment_type">
                      <img src="../assets/img/mastercard_small.png" />
                    </div>
                    <div className="ct_select_payment_type">
                      <img src="../assets/img/pay_pal.png" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group mb-2">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Country{" "}
                      </label>
                      <select className="form-control ct_input">
                        <option>France</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-2">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Name on card
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Enter  name on card"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-2">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Card number
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Enter  card number"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group mb-2">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Expiration date
                      </label>
                      <input type="date" className="form-control ct_input" />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group mb-2">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        CVC/CVV
                      </label>
                      <input
                        type="number"
                        className="form-control ct_input"
                        placeholder=" CVC/CVV"
                      />
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center justify-content-center gap-3 mt-4">
                  <button class="ct_yellow_btn ct_grey_btn ct_h_44  px-5">
                    <i
                      class="fa-solid fa-arrow-left me-1"
                      style={{ color: "#535862" }}
                    ></i>{" "}
                    Back
                  </button>
                  <button
                    class="ct_yellow_btn  ct_sky_blue_btn ct_h_44 px-5"
                    data-bs-toggle="modal"
                    data-bs-target="#ct_submit_modal"
                  >
                    Add method
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade ct_submit_modal "
        id="ct_submit_modal"
        tabindex="-1"
        aria-labelledby="ct_submit_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body py-5">
              <div class="mx-auto d-block text-center mb-4">
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#219EBC"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_18 mx-auto" style={{ maxWidth: "337px" }}>
                  Done! Your payment method is ready to use.
                </h4>
              </div>
              <div class="text-center mt-4">
                <button
                  class="ct_yellow_btn ct_h_48 mx-auto px-5 ct_sky_blue_btn"
                  data-bs-dismiss="modal"
                >
                  View
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade ct_suspend_account"
        id="ct_suspend_account"
        tabindex="-1"
        aria-labelledby="ct_suspend_accountLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body py-5">
              <div class="mx-auto d-block text-center mb-4">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 44V8C4 6.9 4.392 5.95867 5.176 5.176C5.96 4.39333 6.90133 4.00133 8 4H40C41.1 4 42.042 4.392 42.826 5.176C43.61 5.96 44.0013 6.90133 44 8V32C44 33.1 43.6087 34.042 42.826 34.826C42.0433 35.61 41.1013 36.0013 40 36H12L4 44ZM24 30C24.5667 30 25.042 29.808 25.426 29.424C25.81 29.04 26.0013 28.5653 26 28C25.9987 27.4347 25.8067 26.96 25.424 26.576C25.0413 26.192 24.5667 26 24 26C23.4333 26 22.9587 26.192 22.576 26.576C22.1933 26.96 22.0013 27.4347 22 28C21.9987 28.5653 22.1907 29.0407 22.576 29.426C22.9613 29.8113 23.436 30.0027 24 30ZM22 22H26V10H22V22Z"
                    fill="#023047"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_20">Suspend User Account</h4>
                <p>
                  Are you sure you want to suspend
                  <span class="ct_orange_text">Nuray Aksoy</span> account? This
                  will temporarily restrict access to her account on Nuvio.
                </p>
              </div>
              <div class="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                <button
                  class="ct_yellow_btn ct_outline_grey ct_h_48 w-100 px-5 ct_w_100_575"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button class="ct_yellow_btn ct_h_48 mx-auto px-5 w-100 ct_w_100_575 ct_red_btn">
                  Suspend
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalShow && (
        <CoachDisableConfirmationModal
          onClose={() => setIsModalShow(false)}
          handleSubmit={handleDisableAccount}
          title="Disable Account"
          message="Are you sure you want to disable your account?"
        />
      )}
      {isDeleteAccount && (
        <CoachDisableConfirmationModal
          onClose={() => setIsDeleteAccount(false)}
          handleSubmit={handleDeleteAccount}
          title="Delete Account"
          message="Are you sure you want to delete your account? Once deleted, all your data will be permanently lost."
        />
      )}
      {isSubscriptionCancel && (
        <CoachDisableConfirmationModal
          onClose={() => setIsSubscriptionCancel(false)}
          handleSubmit={handlePlanCancelSubScription}
          title="Cancel Your Subscription"
          message="Are you sure you want to cancel your subscription?"
        />
      )}
    </CoachMenuLayout>
  );
};

export default CoachSetting;
